import { render, staticRenderFns } from "./SdThematicTree.vue?vue&type=template&id=24606610&scoped=true"
import script from "./SdThematicTree.vue?vue&type=script&lang=js"
export * from "./SdThematicTree.vue?vue&type=script&lang=js"
import style0 from "./SdThematicTree.vue?vue&type=style&index=0&id=24606610&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24606610",
  null
  
)

export default component.exports